<template>
  <BasePermission
    :permission="permission"
    :model-value="modelValue"
    :disabled="disabled"
    :has-extra-content="modelValue"
    @update:model-value="handleToggle"
  >
    <template #extra-content>
      <div class="pt-3 pl-11">
        <a-radio-group
          :value="selectedAction"
          :disabled="disabled"
          @change="handleActionChange"
        >
          <div class="flex flex-col gap-2">
            <a-radio
              v-for="option in CODEBASE_ACTION_OPTIONS"
              :key="option.value"
              :value="option.value"
            >
              <span class="text-sm secondary_color">{{ option.label }}</span>
              <span class="text-xs secondary_color ml-1">{{ option.description }}</span>
            </a-radio>
          </div>
        </a-radio-group>
      </div>
    </template>
  </BasePermission>
</template>

<script setup>
import { computed } from "vue";
import BasePermission from "./BasePermission.vue";
import { CODEBASE_ACTION_OPTIONS, CODEBASE_ACTIONS } from "@/src/constants/permissionConstants.js";

const props = defineProps({
  permission: { type: Object, required: true },
  modelValue: { type: Boolean, required: true },
  disabled: { type: Boolean, default: false },
  extraValues: { type: Object, default: () => ({}) },
});

const emit = defineEmits(["update:modelValue", "update:extra"]);

const selectedAction = computed(
  () => props.extraValues?.codebaseAction || CODEBASE_ACTIONS.VIEW
);

const handleToggle = (value) => {
  emit("update:modelValue", value);
};

const handleActionChange = (e) => {
  emit("update:extra", {
    key: props.permission.key,
    inputKey: "codebaseAction",
    value: e.target.value,
  });
};
</script>
